import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SaveService } from '../../../../../services/save.service';
import { DialogService } from '../../../../../services/dialog.service';
import { HttpClient } from '@angular/common/http';
import { Utils } from '../../../../../utils/utils';
import { ToastrService } from 'ngx-toastr';
import { FocusPlanHistoryDialogComponent } from '../focusplan-history-dialog/focusplan-history-dialog.component';
import { normalize } from 'path/win32';

@Component({
    selector: 'focusplanimpact-list',
    templateUrl: './focusplanimpact-list.component.html',
    styleUrls: ['./focusplanimpact-list.component.less',
        '../../../../../style/new-generic-styles.component.less'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
            state('expanded', style({ height: '*', })),
            transition('expanded => collapsed', [animate('0ms cubic-bezier(0.4, 0.0, 0.2, 1)')]),
        ]),
    ],
    standalone: false
})
export class FocusPlanListImpactComponent implements OnInit {

    @Input('measureImpactsInfo') measureImpact!: MeasureImpactInfo[];
    @Input('waveId') waveId!: number;
    @Input('isEditModeEnabled') isEditModeEnabled!: boolean;
    @Input('fiscalYear') fiscalYear!: number;
    @Output() refresh = new EventEmitter<string>();
    updatedItems: any[] = [];
    fiscalYearDisplay: string = "";
    columnsToDisplay = ['arrow', 'ItemNo', 'Name', 'Description', 'Kpi', 'KpiUnit', 'ReportingType', 'KpiDescription', "impactHistory"/*, 'BreakdownSelector', 'PeriodSelector'*/];
    subcolumnsToDisplayTemplate = ['item', 'P1', 'P2', 'P3', 'P4', 'P5', 'P6', 'P7', 'P8', 'P9', 'P10', 'P11', 'P12'];
    periods: any[] = [];
    measureImpactTargetSubtableId = 'MeasureImpactTargetSubtableAllPeriods'

    public dataSource = new MatTableDataSource<MeasureImpactInfo>();

    isAllCollapsed: boolean = false;

    expandedElements = new Set();

    dialogRef: any;

    onRefresh: any;

    selectedBreakdown: number = -1;

    selectedPeriod: number = 0;

    actualPYLabel = 'Actual PY'
    actualLabel = 'Actual'
    budgetLabel = 'Budget'
    targetLabel = 'Target % of Budget Achieved'
    targetValueLabel = 'Target'
    deltaActualToTargetLabel = 'Delta (Actual to Target)'
    deltaActualToActualPYLabel = 'Delta (Actual to Actual PY)'
    deltaActualToBudgetLabel = 'Delta (Actual to Budget)'
    hardcodedTargetValueLabel = 'Hard Coded Target'
    totalColumnLabel = 'Total'

    decimals: number = 2;
    hardcodedDecimals: number = 3;
    
    private lastToastTime: number = 0;

    constructor(
        private readonly saveService: SaveService
        , private readonly dialogForm: MatDialog
        , private readonly dialog: DialogService
        , private readonly http: HttpClient
        , @Inject('BASE_URL') private readonly baseUrl: string
        , private readonly toastrService: ToastrService
        , private readonly cdr: ChangeDetectorRef
    ) { }

    ngOnInit(): void {
}

    // trackBy helpers to avoid recreating DOM/column definitions on every change detection cycle
    trackByPeriodId = (_: number, period: any) => period?.id;
    trackByMeasureId = (_: number, measure: MeasureImpactInfo) => measure?.MeasureId;
    trackBySubitem = (_: number, item: any) => item?.item;

    ngOnChanges(changes: any) {
        this.fiscalYearDisplay = (this.fiscalYear - 1) + "/" + this.fiscalYear;

        this.periods = [
            { id: 0, name: 'All periods', key: null, label: null },
            { id: 1, name: 'P1 (OCT - ' + (this.fiscalYear - 1) + ')', key: 'P1', label: 'OCT' },
            { id: 2, name: 'P2 (NOV - ' + (this.fiscalYear - 1) + ')', key: 'P2', label: 'NOV' },
            { id: 3, name: 'P3 (DEC - ' + (this.fiscalYear - 1) + ')', key: 'P3', label: 'DEC' },
            { id: 4, name: 'P4 (JAN - ' + this.fiscalYear + ')', key: 'P4', label: 'JAN' },
            { id: 5, name: 'P5 (FEB - ' + this.fiscalYear + ')', key: 'P5', label: 'FEB' },
            { id: 6, name: 'P6 (MAR - ' + this.fiscalYear + ')', key: 'P6', label: 'MAR' },
            { id: 7, name: 'P7 (APR - ' + this.fiscalYear + ')', key: 'P7', label: 'APR' },
            { id: 8, name: 'P8 (MAY - ' + this.fiscalYear + ')', key: 'P8', label: 'MAY' },
            { id: 9, name: 'P9 (JUN - ' + this.fiscalYear + ')', key: 'P9', label: 'JUN' },
            { id: 10, name: 'P10 (JUL - ' + this.fiscalYear + ')', key: 'P10', label: 'JUL' },
            { id: 11, name: 'P11 (AUG - ' + this.fiscalYear + ')', key: 'P11', label: 'AUG' },
            { id: 12, name: 'P12 (SEP - ' + this.fiscalYear + ')', key: 'P12', label: 'SEP' }
        ];

        if (!this.measureImpact)
            return;
        this.measureImpact?.forEach((x, i) => {
            x.BreakdownSelector = []
            x.Subtables = []
            let counter = 0;
            let isKpipercentage = x.KpiUnit === 'Percentage';

            // Remove existing summed values breakdown if it exists
            x.Breakdowns = x.Breakdowns.filter(b => b.Breakdown !== 'BrakdownSummedValues');

            // Initialize sum objects
            const sumActualPY = { P1: 0, P2: 0, P3: 0, P4: 0, P5: 0, P6: 0, P7: 0, P8: 0, P9: 0, P10: 0, P11: 0, P12: 0 };
            const sumActual = { P1: 0, P2: 0, P3: 0, P4: 0, P5: 0, P6: 0, P7: 0, P8: 0, P9: 0, P10: 0, P11: 0, P12: 0 };
            const sumBudget = { P1: 0, P2: 0, P3: 0, P4: 0, P5: 0, P6: 0, P7: 0, P8: 0, P9: 0, P10: 0, P11: 0, P12: 0 };

            // Sum the values from each breakdown
            x.Breakdowns.forEach(y => {
                for (const key in sumActualPY) {
                    if (y.ActualPY[key]) {
                        sumActualPY[key] += y.ActualPY[key];
                    }
                    if (y.Actual[key]) {
                        sumActual[key] += y.Actual[key];
                    }
                    if (y.Budget[key]) {
                        sumBudget[key] += y.Budget[key];
                    }
                }
            });

            // Convert sums to 2 decimal digits
            for (const key in sumActualPY) {
                sumActualPY[key] = this.formatValue(sumActualPY[key]);
                sumActual[key] = this.formatValue(sumActual[key]);
                sumBudget[key] = this.formatValue(sumBudget[key]);
            }

            x.Breakdowns.forEach((y, index) => {
                const sumActualPY = this.calculateSum(y.ActualPY, isKpipercentage);
                const sumActual = this.calculateSum(y.Actual, isKpipercentage);
                const sumBudget = this.calculateSum(y.Budget, isKpipercentage);
                const deltaActualToActualPY = this.subtractNestedObjects(y.Actual, y.ActualPY);
                const deltaActualToBudget = this.subtractNestedObjects(y.Actual, y.Budget);
                const sumDeltaActualToActualPY = this.calculateSum(deltaActualToActualPY, isKpipercentage);
                const sumDeltaActualToBudget = this.calculateSum(deltaActualToBudget, isKpipercentage);
                x.Subtables.push(
                    [
                        { item: this.actualPYLabel, ...y.ActualPY, Total: this.formatNumber(sumActualPY) },
                        { item: this.actualLabel, ...y.Actual, Total: this.formatNumber(sumActual) },
                        { item: this.budgetLabel, ...y.Budget, Total: this.formatNumber(sumBudget) },
                        { item: this.targetLabel, ...y.Target },
                        { item: this.targetValueLabel },
                        { item: this.deltaActualToTargetLabel },
                        { item: this.deltaActualToActualPYLabel, ...deltaActualToActualPY, Total: this.formatNumber(sumDeltaActualToActualPY) },
                        { item: this.deltaActualToBudgetLabel, ...deltaActualToBudget, Total: this.formatNumber(sumDeltaActualToBudget) },
                        { item: this.hardcodedTargetValueLabel, ...y.HardcodedTarget }
                    ]
                )
                x.BreakdownSelector.push({ id: counter++, label: y.Breakdown });
                x.SelectedBreakdown = 0
            });

            x.PeriodSelector = this.periods
            x.SelectedPeriod = 0
            x.ItemNo = ++i
            x.subColumnsToDisplay = x.ReportingType === 'MTD' ? [...this.subcolumnsToDisplayTemplate, 'Total'] : this.subcolumnsToDisplayTemplate;
        })
        this.dataSource.data = this.measureImpact
        this.cdr.markForCheck();

    }

    pushPopElement(element: MeasureImpactInfo) {
        if (this.expandedElements.has(element.MeasureId)) {
            this.expandedElements.delete(element.MeasureId);
        }
        else {
            this.expandedElements.add(element.MeasureId);
        }
        this.cdr.markForCheck();
    }

    checkExpanded(element: MeasureImpactInfo): boolean {
        return this.expandedElements.has(element.MeasureId);
    }

    isEditableFieldEnabled(item: string) {
        return (item === this.targetLabel || item === this.hardcodedTargetValueLabel)
            && this.isEditModeEnabled === true
    }

    getIsEditModeEnabled() {
        return this.isEditModeEnabled === true
    }

    getTotalHeaderLabel(measure: MeasureImpactInfo) {
        return measure.KpiUnit === 'Percentage' ? 'Average (%)' : 'Total';
    }

    onChange(measure: MeasureImpactInfo, period: number, measureTargetId: number, $event: any, item: string, test: any) {

        const breakdown = this.dataSource.data.filter(x => x.KpiDefinitionId === measure.KpiDefinitionId)[0].Subtables[0]

        const index = this.updatedItems.findIndex(
            (obj) =>
                obj.KpiBreakdown1Id === breakdown.KpiBreakdown1Id &&
                obj.KpiBreakdown2Id === breakdown.KpiBreakdown2Id &&
                obj.KpiProductHierarchyId === breakdown.KpiProductHierarchyId &&
                obj.KpiMovementTypeId === breakdown.KpiMovementTypeId &&
                obj.KpiDefinitionId === measure.KpiDefinitionId &&
                obj.Period === period &&
                obj.MeasureId === measure.MeasureId)

        if (index >= 0) {
            this.updatedItems.splice(index, 1)
        }

        if (item === this.hardcodedTargetValueLabel && measure.KpiUnit === 'Percentage') {
            if ($event < -1 || $event > 1) {
                return;
            }
        }

        this.updatedItems.push({
            KpiBreakdown1Id: breakdown.KpiBreakdown1Id,
            KpiBreakdown2Id: breakdown.KpiBreakdown2Id,
            KpiMovementTypeId: breakdown.KpiProductHierarchyId,
            KpiProductHierarchyId: breakdown.KpiProductHierarchyId,
            KpiDefinitionId: measure.KpiDefinitionId,
            Period: period,
            MeasureId: measure.MeasureId,
            MeasureTargetId: measureTargetId,
            Value: $event,
            IsHardcoded: item === this.hardcodedTargetValueLabel,
        })
    }
    validateHardcodedTarget(event: KeyboardEvent, measure: MeasureImpactInfo, period: string, item: string = '') {
        const breakdown = this.dataSource.data.filter(x => x.KpiDefinitionId === measure.KpiDefinitionId)[0].Subtables[0];

        const targetValue = breakdown.find(x => x.item === this.targetLabel)?.[period] || null;
        const hardcodedTargetValue = breakdown.find(x => x.item === this.hardcodedTargetValueLabel)?.[period] || null;

        const currentTime = Date.now();

        if (item === this.targetLabel && hardcodedTargetValue !== null) {
            if (currentTime - this.lastToastTime >= 5000) {
                this.toastrService.warning('Cannot provide a Target % when Hardcoded Value is provided', '');
                this.lastToastTime = currentTime;
            }
            event.preventDefault();
            return;
        }

        if (item === this.hardcodedTargetValueLabel && targetValue !== null) {
            if (currentTime - this.lastToastTime >= 5000) {
                this.toastrService.warning('Cannot provide a Hardcoded Value when Target % is provided.', '');
                this.lastToastTime = currentTime;
            }
            event.preventDefault();
            return;
        }
    }

    onSelect($event: any, kpiDefinitionId: number) {
        const measure = this.dataSource.data.filter(x => x.KpiDefinitionId === kpiDefinitionId)[0]
        measure.SelectedBreakdown = $event.id
        this.cdr.markForCheck();
    }

    onSelectPeriod($event: any, kpiDefinitionId: number) {
        const measure = this.dataSource.data.filter(x => x.KpiDefinitionId === kpiDefinitionId)[0]
        if ($event.id == 0) {
            measure.subColumnsToDisplay = this.subcolumnsToDisplayTemplate;
            this.measureImpactTargetSubtableId = 'MeasureImpactTargetSubtableAllPeriods';
        }
        else {
            measure.subColumnsToDisplay = ['item', 'P' + $event.id];
            this.measureImpactTargetSubtableId = 'MeasureImpactTargetSubtableOnePeriod';
        }
        this.cdr.markForCheck();
    }

    onInputBlur(item: any, periodKey: string, kpiUnit: string): void {
        let rawValue = item[periodKey];

        if (kpiUnit !== 'Percentage')
            return;

        if (rawValue === undefined || rawValue === null || rawValue === '') {
            return;
        }

        // Normalize commas to points (optional)
        let normalized = rawValue.toString().replace(',', '.');

        let numericValue = parseFloat(normalized);
        if (isNaN(numericValue)) {
            item[periodKey] = ''; // clear or handle as needed
            return;
        }

        if (item.item === this.hardcodedTargetValueLabel && (numericValue < -1 || numericValue > 1)) {
            this.toastrService.warning('Hard Coded Target must be between -1 and 1', '');
            item[periodKey] = '';
            return;
        }

        // Format to 2 decimals
        item[periodKey] = numericValue
    }
    getTarget(subtables: any[], selectedBreakdown: number, period: string) {
        const percentageTarget = this.getPercentageTargetValue(subtables, selectedBreakdown, period); // Target % of Budget Achieved
        const hardcodedTarget = this.getHardcodedTarget(subtables, selectedBreakdown, period); // Hardcoded Target Value
        if (percentageTarget === null && hardcodedTarget === null)
            return null;
        return percentageTarget + hardcodedTarget
    }

    getPercentageTarget(subtables: any[], selectedBreakdown: number, period: string) {
        const target = subtables[selectedBreakdown][3][period];
        if (this.isEmptyValue(target))
            return null;
        return this.formatValue(target); // Target % of Budget Achieved
    }

    getPercentageTargetValue(subtables: any[], selectedBreakdown: number, period: string) {
        const target = subtables[selectedBreakdown][3][period];
        const budget = subtables[selectedBreakdown][2][period];
        if (this.isEmptyValue(target) || this.isEmptyValue(budget))
            return null;
        return this.formatValue((target * budget) / 100); // (Target % of Budget Achieved * Budget) / 100
    }

    private isEmptyValue(value: any): boolean {
        return value === null || value === undefined || value === '';
    }

    getHardcodedTarget(subtables: any[], selectedBreakdown: number, period: string) {
        if (subtables[selectedBreakdown][8] == null) {
            return null;
        }
        const hardcoded = subtables[selectedBreakdown][8][period];
        if (this.isEmptyValue(hardcoded)) {
            return null;
        }
        return this.formatValue(hardcoded, 3); // Hardcoded Target Value
    }

    calculateSum(values: any, isAverage: boolean, decimals: number = this.decimals): number | undefined {
        const filteredValues = Object.values(values).filter((value: any) => value != undefined && value != null);
        if (filteredValues.length < 1)
            return undefined
        const sum = filteredValues.reduce((sum: number, value: any) => sum + this.formatValue(value || 0, decimals), 0);
        return isAverage && filteredValues.length > 0 ? sum / filteredValues.length : sum;
    }


    getSumPercentageTarget(measure: MeasureImpactInfo) {
        const breakdown = measure.Subtables[measure.SelectedBreakdown];
        if (!breakdown || !Array.isArray(breakdown)) {
            return undefined;
        }

        const values = [
            this.getPercentageTarget(measure.Subtables, measure.SelectedBreakdown, 'P1'), this.getPercentageTarget(measure.Subtables, measure.SelectedBreakdown, 'P2'),
            this.getPercentageTarget(measure.Subtables, measure.SelectedBreakdown, 'P3'), this.getPercentageTarget(measure.Subtables, measure.SelectedBreakdown, 'P4'),
            this.getPercentageTarget(measure.Subtables, measure.SelectedBreakdown, 'P5'), this.getPercentageTarget(measure.Subtables, measure.SelectedBreakdown, 'P6'),
            this.getPercentageTarget(measure.Subtables, measure.SelectedBreakdown, 'P7'), this.getPercentageTarget(measure.Subtables, measure.SelectedBreakdown, 'P8'),
            this.getPercentageTarget(measure.Subtables, measure.SelectedBreakdown, 'P9'), this.getPercentageTarget(measure.Subtables, measure.SelectedBreakdown, 'P10'),
            this.getPercentageTarget(measure.Subtables, measure.SelectedBreakdown, 'P11'), this.getPercentageTarget(measure.Subtables, measure.SelectedBreakdown, 'P12')
        ];

        const sum = this.calculateSum(values, true);
        return this.formatNumber(sum);
    }

    getSumHardcodedTarget(measure: MeasureImpactInfo) {
        const breakdown = measure.Subtables[measure.SelectedBreakdown];
        if (!breakdown || !Array.isArray(breakdown)) {
            return undefined;
        }

        const values = [
            this.getHardcodedTarget(measure.Subtables, measure.SelectedBreakdown, 'P1'), this.getHardcodedTarget(measure.Subtables, measure.SelectedBreakdown, 'P2'),
            this.getHardcodedTarget(measure.Subtables, measure.SelectedBreakdown, 'P3'), this.getHardcodedTarget(measure.Subtables, measure.SelectedBreakdown, 'P4'),
            this.getHardcodedTarget(measure.Subtables, measure.SelectedBreakdown, 'P5'), this.getHardcodedTarget(measure.Subtables, measure.SelectedBreakdown, 'P6'),
            this.getHardcodedTarget(measure.Subtables, measure.SelectedBreakdown, 'P7'), this.getHardcodedTarget(measure.Subtables, measure.SelectedBreakdown, 'P8'),
            this.getHardcodedTarget(measure.Subtables, measure.SelectedBreakdown, 'P9'), this.getHardcodedTarget(measure.Subtables, measure.SelectedBreakdown, 'P10'),
            this.getHardcodedTarget(measure.Subtables, measure.SelectedBreakdown, 'P11'), this.getHardcodedTarget(measure.Subtables, measure.SelectedBreakdown, 'P12')
        ];

        const sum = this.calculateSum(values, measure.KpiUnit === 'Percentage', 3);
        return this.formatNumber(sum, this.hardcodedDecimals);
    }

    getSumTarget(measure: MeasureImpactInfo) {
        const breakdown = measure.Subtables[measure.SelectedBreakdown];
        if (!breakdown || !Array.isArray(breakdown)) {
            return this.formatNumber(0);
        }

        const values = [
            this.getTarget(measure.Subtables, measure.SelectedBreakdown, 'P1'), this.getTarget(measure.Subtables, measure.SelectedBreakdown, 'P2'),
            this.getTarget(measure.Subtables, measure.SelectedBreakdown, 'P3'), this.getTarget(measure.Subtables, measure.SelectedBreakdown, 'P4'),
            this.getTarget(measure.Subtables, measure.SelectedBreakdown, 'P5'), this.getTarget(measure.Subtables, measure.SelectedBreakdown, 'P6'),
            this.getTarget(measure.Subtables, measure.SelectedBreakdown, 'P7'), this.getTarget(measure.Subtables, measure.SelectedBreakdown, 'P8'),
            this.getTarget(measure.Subtables, measure.SelectedBreakdown, 'P9'), this.getTarget(measure.Subtables, measure.SelectedBreakdown, 'P10'),
            this.getTarget(measure.Subtables, measure.SelectedBreakdown, 'P11'), this.getTarget(measure.Subtables, measure.SelectedBreakdown, 'P12')
        ];

        const sum = this.calculateSum(values, measure.KpiUnit === 'Percentage');
        return this.formatNumber(sum);
    }

    getSumActualToTarget(measure: MeasureImpactInfo) {
        const breakdown = measure.Subtables[measure.SelectedBreakdown];
        if (!breakdown || !Array.isArray(breakdown)) {
            return this.formatNumber(0);
        }

        const values = [
            this.getDeltaTarget(measure.Subtables, measure.SelectedBreakdown, 'P1'), this.getDeltaTarget(measure.Subtables, measure.SelectedBreakdown, 'P2'),
            this.getDeltaTarget(measure.Subtables, measure.SelectedBreakdown, 'P3'), this.getDeltaTarget(measure.Subtables, measure.SelectedBreakdown, 'P4'),
            this.getDeltaTarget(measure.Subtables, measure.SelectedBreakdown, 'P5'), this.getDeltaTarget(measure.Subtables, measure.SelectedBreakdown, 'P6'),
            this.getDeltaTarget(measure.Subtables, measure.SelectedBreakdown, 'P7'), this.getDeltaTarget(measure.Subtables, measure.SelectedBreakdown, 'P8'),
            this.getDeltaTarget(measure.Subtables, measure.SelectedBreakdown, 'P9'), this.getDeltaTarget(measure.Subtables, measure.SelectedBreakdown, 'P10'),
            this.getDeltaTarget(measure.Subtables, measure.SelectedBreakdown, 'P11'), this.getDeltaTarget(measure.Subtables, measure.SelectedBreakdown, 'P12')
        ];

        const sum = this.calculateSum(values, measure.KpiUnit === 'Percentage');
        return this.formatNumber(sum);
    }

    getDeltaTarget(subtables: any[], selectedBreakdown: number, period: string) {
        if (this.getTarget(subtables, selectedBreakdown, period) == null || this.formatValue(subtables[selectedBreakdown][1][period]) == null) {
            return null
        }
        return this.formatValue(subtables[selectedBreakdown][1][period] - // Actual
                    this.getTarget(subtables, selectedBreakdown, period))
            ;
    }


    subtractNestedObjects(obj1: MeasurePeriodValue, obj2: MeasurePeriodValue): MeasurePeriodValue {
        const result = {} as MeasurePeriodValue;
        const periods = [
            'P1', 'P2', 'P3', 'P4', 'P5', 'P6',
            'P7', 'P8', 'P9', 'P10', 'P11', 'P12'
        ];

        for (const key of periods) {
            const val1 = obj1?.[key];
            const val2 = obj2?.[key];
            result[key] = (val1 != null && val2 != null)
                ? this.formatValue(val1 - val2)
                : undefined;
        }

        return result;
    }

    showDropdown(items) {
        if (items.length == 1) {
            if (items[0].id == 0 && !items[0].label) {
                return false
            }
        }
        return true
    }

    formatNumber = (value, decimals = this.decimals) => {
        if (value === undefined || value === null || Number.isNaN(value)) {
            return '';
        }
        else
            return parseFloat(value).toLocaleString('de', { maximumFractionDigits: decimals });
    };

    formatValue = (value, decimals = this.decimals) => {
        return value % 1 === 0 ? value : parseFloat(value.toFixed(decimals));
    };

    collapseOrExpandAll() {
        if (this.isAllCollapsed === false) {
            this.isAllCollapsed = true;
            this.dataSource.data.forEach((el) => {
                if (!this.checkExpanded(el)) {
                    this.pushPopElement(el);
                }
            });
        } else {
            this.isAllCollapsed = false;
            this.expandedElements.clear();
        }
        this.cdr.markForCheck();
    }

    onImpactHistoryDetail(measure: MeasureImpactInfo) {
        const config = FocusPlanHistoryDialogComponent.createImpactConfig(measure);
        this.dialogForm.open(FocusPlanHistoryDialogComponent, {
            panelClass: 'custom-mat-dialog',
            disableClose: false,
            width: '1200px',
            maxWidth: '95vw',
            maxHeight: '80vh',
            data: config
        });
    }
}